import * as type from '../../types/trans';
import { HEADER_KEY } from '../../types/preloginType';

export const cvlData = (data) => {
    console.log("cvlData data", data);
    return {
        type: type.SAVE_CVL_DATA,
        payload: data
    }
}

export const updateGuest = (data) => {
    console.log("updateGuest data", data);
    return {
        type: type.UPDATE_GUEST_MENU,
    }
}

export const resetGuest = (data) => {
    console.log("resetGuest data", data);
    return {
        type: type.RESET_GUEST_MENU,
    }
}

export const existContainer = (data) => {
    return {
        type: type.EXISTING_BOX,
        payload: data
    }
}

export const HeaderKey = (data) => {
    return {
        type: HEADER_KEY,
        payload: data
    }
}

export const getCartCount = (data) => {
    console.log("getCartCount--->", data)
    return {
        type: type.GET_CART_COUNT,
        payload: data
    }
}

export const updateGuestType = (data) => {
    return {
        type: type.UPDATE_GUEST_MENU,
        payload: data
    }
}

export const selectedRIData = (data) => {
    console.log("data auth", data)
    return {
        type: type.SELECTED_RI_DATA,
        payload: data
    }
}


export const RIStatus = (data) => {
    console.log("data auth", data)
    return {
        type: type.RIStatus,
        payload: data
    }
}
